var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSemiTruckHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29427",
    "data-name": "Group 29427",
    transform: "translate(-355 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(355 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29426",
    "data-name": "Group 29426",
    transform: "translate(-18.508 -2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50884",
    "data-name": "Path 50884",
    d: "M159.529,55.792c-.115.2-.208.371-.265.481a.087.087,0,0,1-.049.049.112.112,0,0,1-.155-.049c-.057-.106-.155-.278-.265-.481a8.661,8.661,0,0,1-1.1-2.43,1.462,1.462,0,0,1,2.924,0A8.661,8.661,0,0,1,159.529,55.792Z",
    transform: "translate(239.362 460.98)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50885",
    "data-name": "Path 50885",
    d: "M166.713,59.8a1.1,1.1,0,0,1,.786.327,1.12,1.12,0,0,1,.327.786,1.113,1.113,0,1,1-1.9-.786A1.119,1.119,0,0,1,166.713,59.8Z",
    transform: "translate(231.812 453.43)",
    fill: "#c24441",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50886",
    "data-name": "Path 50886",
    d: "M172.493,65.456a.874.874,0,1,0,.256.618A.875.875,0,0,0,172.493,65.456Z",
    transform: "translate(226.65 448.269)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50887",
    "data-name": "Path 50887",
    d: "M11.535,28.457c-.137.243-.256.455-.322.588a.156.156,0,0,1-.057.062.144.144,0,0,1-.19-.057c-.071-.133-.186-.34-.322-.588A10.463,10.463,0,0,1,9.3,25.489a1.765,1.765,0,0,1,.526-1.263,1.8,1.8,0,0,1,1.263-.526,1.772,1.772,0,0,1,1.263.526,1.791,1.791,0,0,1,.526,1.263A10.646,10.646,0,0,1,11.535,28.457Z",
    transform: "translate(381.208 487.936)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50888",
    "data-name": "Path 50888",
    d: "M20.361,33.4a1.357,1.357,0,1,1-.963.4A1.355,1.355,0,0,1,20.361,33.4Z",
    transform: "translate(371.937 478.664)",
    fill: "#c24441",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50889",
    "data-name": "Path 50889",
    d: "M27.424,40.314a1.069,1.069,0,1,0,0,1.511,1.066,1.066,0,0,0,0-1.511Z",
    transform: "translate(365.628 472.355)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50894",
    "data-name": "Path 50894",
    d: "M13.7,171.808a.207.207,0,0,1,.208-.208h12.13a.207.207,0,0,1,.208.208V181.7a.207.207,0,0,1-.208.208H13.908a.207.207,0,0,1-.208-.208Z",
    transform: "translate(377.002 346.568)",
    fill: "#729bc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50895",
    "data-name": "Path 50895",
    d: "M23.356,330.546H19.345a1.6,1.6,0,0,1-.009-.208,2.019,2.019,0,0,1,4.037,0C23.365,330.409,23.361,330.479,23.356,330.546Zm-4.174,0H15.171a1.6,1.6,0,0,1-.009-.208,2.019,2.019,0,0,1,4.037,0C19.191,330.409,19.186,330.479,19.182,330.546ZM13.7,327.1H26.241v1.025H13.7Z",
    transform: "translate(377.002 197.938)",
    fill: "#4c6682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50896",
    "data-name": "Path 50896",
    d: "M68.543,364.668a1.6,1.6,0,1,1-.468,1.131A1.589,1.589,0,0,1,68.543,364.668Zm-7.8,0a1.6,1.6,0,1,1-.468,1.131A1.615,1.615,0,0,1,60.743,364.668Zm-4.174,0A1.6,1.6,0,1,1,56.1,365.8,1.615,1.615,0,0,1,56.568,364.668Z",
    transform: "translate(336.475 162.476)",
    fill: "#2e343a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50897",
    "data-name": "Path 50897",
    d: "M70.32,377.3a1,1,0,0,0-.72.3,1.04,1.04,0,0,0-.3.724,1.021,1.021,0,1,0,1.02-1.025Z",
    transform: "translate(323.858 149.955)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50898",
    "data-name": "Path 50898",
    d: "M81.146,389.15a.5.5,0,0,1,.861.358.515.515,0,0,1-.146.358.493.493,0,0,1-.358.15.509.509,0,0,1-.358-.866Z",
    transform: "translate(312.675 138.771)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50903",
    "data-name": "Path 50903",
    d: "M164.725,377.3a1.026,1.026,0,1,0,.724.3A1.021,1.021,0,0,0,164.725,377.3Z",
    transform: "translate(233.628 149.955)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50904",
    "data-name": "Path 50904",
    d: "M175.55,389.15a.5.5,0,1,1-.15.358A.5.5,0,0,1,175.55,389.15Z",
    transform: "translate(222.444 138.771)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50907",
    "data-name": "Path 50907",
    d: "M68.532,186.4h6.489a.633.633,0,0,1,.632.632v4.3a.633.633,0,0,1-.632.632H68.532a.633.633,0,0,1-.632-.632v-4.3a.633.633,0,0,1,.632-.632Z",
    transform: "translate(325.196 332.423)",
    fill: "#ffd47d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50908",
    "data-name": "Path 50908",
    d: "M102.2,186.4h1.453v2.889a.133.133,0,0,1-.133.133.121.121,0,0,1-.11-.062l-.486-.623-.49.632a.133.133,0,0,1-.186.022.125.125,0,0,1-.049-.1Zm3.273,0h1.453v2.889a.133.133,0,0,1-.133.133.121.121,0,0,1-.11-.062l-.486-.623-.49.632a.133.133,0,0,1-.186.022.125.125,0,0,1-.049-.1Z",
    transform: "translate(292.411 332.423)",
    fill: "#edaf54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50909",
    "data-name": "Path 50909",
    d: "M87.733,263.5H88.7a.133.133,0,0,1,.133.133v1.246a.133.133,0,0,1-.133.133h-.972a.133.133,0,0,1-.133-.133v-1.246A.139.139,0,0,1,87.733,263.5Zm1.793,0H90.5a.133.133,0,0,1,.133.133v1.246a.133.133,0,0,1-.133.133h-.972a.133.133,0,0,1-.133-.133v-1.246A.139.139,0,0,1,89.526,263.5Z",
    transform: "translate(306.366 258.728)",
    fill: "#d78e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50910",
    "data-name": "Path 50910",
    d: "M168.933,263.765a.133.133,0,0,1-.133-.133.13.13,0,0,1,.133-.133h2.16a.133.133,0,0,1,.133.133.13.13,0,0,1-.133.133Zm0,.623a.133.133,0,0,1,0-.265h2.16a.133.133,0,1,1,0,.265Zm0,.623a.133.133,0,0,1,0-.265h2.16a.133.133,0,0,1,0,.265Z",
    transform: "translate(228.753 258.728)",
    fill: "#edaf54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50911",
    "data-name": "Path 50911",
    d: "M101.593,15.675a.212.212,0,1,1-.34.252,1.825,1.825,0,0,0-.389-.393,1.52,1.52,0,0,0-1.838,0,1.825,1.825,0,0,0-.389.393.212.212,0,0,1-.34-.252,2.349,2.349,0,0,1,.477-.481,1.933,1.933,0,0,1,1.166-.393,1.962,1.962,0,0,1,1.166.393A2.092,2.092,0,0,1,101.593,15.675Zm3.1.331a.212.212,0,1,1,.088-.415,3.894,3.894,0,0,1,2.836,3.587.211.211,0,1,1-.42.049A3.463,3.463,0,0,0,104.689,16.006Z",
    transform: "translate(296.182 496.442)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50881",
    "data-name": "Path 50881",
    d: "M328.6,21.612c-.2.349-.367.649-.464.839a.23.23,0,0,1-.084.088.2.2,0,0,1-.269-.084c-.1-.19-.269-.49-.464-.844-.751-1.338-1.917-3.423-1.917-4.249a2.562,2.562,0,0,1,5.124,0C330.52,18.188,329.349,20.273,328.6,21.612Z",
    transform: "translate(79.07 496.442)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50882",
    "data-name": "Path 50882",
    d: "M341.244,28.7a1.943,1.943,0,0,1,1.374,3.317,1.955,1.955,0,0,1-1.374.57,1.929,1.929,0,0,1-1.374-.57,1.955,1.955,0,0,1-.57-1.374,1.946,1.946,0,0,1,1.944-1.944Z",
    transform: "translate(65.784 483.156)",
    fill: "#c24441",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50883",
    "data-name": "Path 50883",
    d: "M351.215,38.451a1.525,1.525,0,1,0,.451,1.087A1.54,1.54,0,0,0,351.215,38.451Z",
    transform: "translate(56.896 474.267)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50890",
    "data-name": "Path 50890",
    d: "M288.508,229.706a.207.207,0,0,1-.208-.208v-7.691a.207.207,0,0,1,.208-.208h4.678a.206.206,0,0,1,.194.137l1.546,3.817a.25.25,0,0,1,.013.079v.813h-.495a.437.437,0,0,0,0,.875h.495V229.5a.207.207,0,0,1-.208.208Q291.617,229.7,288.508,229.706Z",
    transform: "translate(114.532 298.777)",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50891",
    "data-name": "Path 50891",
    d: "M321.82,356.926h-4.011a1.6,1.6,0,0,1-.009-.208,2.019,2.019,0,0,1,4.037,0C321.829,356.789,321.829,356.86,321.82,356.926Z",
    transform: "translate(86.335 171.557)",
    fill: "#9e3735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50892",
    "data-name": "Path 50892",
    d: "M330.389,366.007h-3.176a1.6,1.6,0,1,1,3.185-.208A1.074,1.074,0,0,1,330.389,366.007Z",
    transform: "translate(77.35 162.477)",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50893",
    "data-name": "Path 50893",
    d: "M316.212,249.5h2.619a.206.206,0,0,1,.194.137l1.144,2.827a.207.207,0,0,1-.115.269.251.251,0,0,1-.08.013h-3.768a.207.207,0,0,1-.208-.208V249.7A.21.21,0,0,1,316.212,249.5Zm.742,3.666a.208.208,0,0,1,0,.415h-.742a.208.208,0,0,1,0-.415Z",
    transform: "translate(88.056 272.109)",
    fill: "#9e3735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50899",
    "data-name": "Path 50899",
    d: "M327.775,258.8H325.5v2.425h3.251Z",
    transform: "translate(78.976 263.221)",
    fill: "#bfddff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50900",
    "data-name": "Path 50900",
    d: "M334.5,258.8h-.3l-1.4,2.425h.3Zm-.786,2.425h.3l1.012-1.754-.124-.3Z",
    transform: "translate(71.998 263.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50901",
    "data-name": "Path 50901",
    d: "M409.543,322v.415h-.495a.437.437,0,1,0,0,.875h.495v.415h-.495a.848.848,0,0,1,0-1.7Z",
    transform: "translate(-0.072 202.812)",
    fill: "#9e3735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50902",
    "data-name": "Path 50902",
    d: "M418.432,331.2v.87h-.495a.437.437,0,1,1,0-.875Z",
    transform: "translate(-8.961 194.019)",
    fill: "#ffe26f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50905",
    "data-name": "Path 50905",
    d: "M341.225,377.3a1.026,1.026,0,1,0,.724.3A1.022,1.022,0,0,0,341.225,377.3Z",
    transform: "translate(64.924 149.955)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50906",
    "data-name": "Path 50906",
    d: "M352.15,389.15a.5.5,0,1,1-.15.358A.5.5,0,0,1,352.15,389.15Z",
    transform: "translate(53.646 138.771)",
    fill: "#e6e6e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiTruckHighlighted);
export default __webpack_public_path__ + "static/media/semiTruckHighlighted.4b4e6065235ab03230fb203acb95ae42.svg";
export { ForwardRef as ReactComponent };